import * as mutationTypes from '@/store/mutationTypes';
import { mapActions, mapGetters } from 'vuex'
import ConnectionMonitor from '@/wrappers/ConnectionMonitor'

import TenantService from '@/services/TenantService';
import UserService from '@/services/UserService';

const OFFLINE_FROM_KEY = 'offline-from';

export default {
    created() {
        ConnectionMonitor.init(this.onDeviceOnline, this.onDeviceOffline)
    },

    beforeDestroy() {
        ConnectionMonitor.destroy()

        this.stopPeriodicConnectionCheck()
    },

    data: () => {
        return {
            connCheckInterval: null,
        };
    },

    watch: {
        isOnline(val, oldVal) {
            // if change occurred show the appropriate snackbar message
            if (val && !oldVal) {
                this.$snackbar(this.$t('connection.internet_online_message_again'), 'success');

                if(this.echo) {
                    this.echo.reload();
                    this.joinChannels();
                }

                if(!TenantService.getToken()) {
                    UserService.removeToken();
                    UserService.removeUser();

                    TenantService.removeTenant();
                    this.$router.push({ name: 'tenantLogin' }).catch(err => {});
                } else if(!UserService.getToken()) {
                    UserService.removeUser();
                    this.$router.push({ name: 'userLogin' }).catch(err => {});
                }
            } else if (!val && oldVal) {
                this.$snackbar(this.$t('connection.internet_offline_message'), 'error', { timeout: 10000 });
            }

            // if offline detected, start checking the connection each 20s
            // when we are back online, try sync and if successfull stop checking
            if (!val) {
                this.startPeriodicConnectionCheck()
            } else {
                this.stopPeriodicConnectionCheck()
            }
        },
    },

    computed: {
        ...mapGetters(['isOnline'])
    },

    methods: {
        ...mapActions(['connectionCheck']),

        onDeviceOnline() {
            this.connectionCheck()
        },

        onDeviceOffline() {
            const offlineFrom = AppStorage.local().getItem(OFFLINE_FROM_KEY);
            const offlineLimitMinutes = locale === 'me' ? (2 * 24 * 60) : (5 * 24 * 60)
            if(!offlineFrom) {
                AppStorage.local().setItem(OFFLINE_FROM_KEY, moment().format('YYYY-MM-DD HH:mm:ss'));
            } else if(moment().diff(moment(offlineFrom), 'minutes') > offlineLimitMinutes) {
                EventBus.$emit('show-offline-too-long');
            }

            this.$store.commit(mutationTypes.SET_IS_ONLINE, { isOnline: false });
        },

        startPeriodicConnectionCheck() {
            clearInterval(this.connCheckInterval);

            this.connCheckInterval = setInterval(() => {
                this.connectionCheck()
            }, 20000);
        },

        stopPeriodicConnectionCheck() {
            clearInterval(this.connCheckInterval);
            this.connCheckInterval = null
        }
    }
};
